import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleSheets = defineConnector({
  identifier: "googleSheets",
  name: "Google Sheets",
  tagLine: "Spreadsheets",
  keywords: "gsheets spreadsheets cells rows workspace g suite",
  logo,
  protocol: "http",
  tags: ["featured", "data", "documents"],
  defaultUrlPattern: () => "https://sheets\\.googleapis\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Google Sheets",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.google.com/o/oauth2/v2/auth",
    tokenEndpoint: () => "https://oauth2.googleapis.com/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
    authorizationParameters: () => ({
      access_type: "offline",
      prompt: "consent",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://sheets.googleapis.com/v4/spreadsheets/test",
      expectedStatus: 404,
    }),
  },
});
